<template>
    <div class="expediting-records-container">
        <div class="screen">
            <span class="btn" @click="open_screen">筛选</span>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="项目征集" name="1">
                <CommonTable5 :tableTitle="tableTitle1" :tableData="tableData1" :btnList="btnList1"/>
            </el-tab-pane>
            <el-tab-pane label="渠道分发" name="2">
                <CommonTable5 :tableTitle="tableTitle2" :tableData="tableData2" :btnList="btnList2"></CommonTable5>
            </el-tab-pane>
        </el-tabs>
        <Rawer :drawer="drawer" :direction="direction" :rawer_list="rawer_list" @screen="screen" @handleClose_drawer="handleClose_drawer"></Rawer>
        <PaginationModular @set_page="set_page" @set_limit="set_limit" 
            :data_obj="data_obj" :page="page" :limit="limit"
        />
    </div>
</template>

<script>
import CommonTable5 from '@/components/commonTable5'
import Rawer from '@/components/drawer/drawer'
import PaginationModular from '@/components/pagination_modular/pagination_modular.vue'
export default {
    components:{
        CommonTable5,
        Rawer,
        PaginationModular
    },
    data() {
      return {
        data_obj:{},
        page:1,
        limit:10,
        btnList1:[
            {
                _this:this,
                btn:"审核详情",
                fun(val){
                    this._this.router.push({path:"/projectManagement/projectList/projectDetial",query:{id:val.project_id}});
                }
            },
        ],
        btnList2:[
            {
                _this:this,
                btn:"审核详情",
                fun(val){
                    console.log('fun',val)
                    this._this.router.push({path:"/review/audit-details",query:{id:val.check_id,type:10}});
                }
            },
        ],
        activeName:'1',
        tabs_list:[
            {label:'渠道分发',name:'first',tableTitle:'tableTitle1',tableData:'tableData2'},
            {label:'项目征集',name:'second',tableTitle:'tableTitle2',tableData:'tableData1'},
            {label:'摄影投稿',name:'third',tableTitle:'tableTitle3',tableData:'tableData3'},
        ],
        //渠道分发表头
        tableTitle2:[
            {label:'用户ID',prop:'open_id'},
            {label:'用户头像',prop:'avatar'},
            {label:'用户昵称',prop:'username'},
            {label:'作品ID',prop:'work_id'},
            {label:'作品封面',prop:'face_pic'},
            {label:'作品名称',prop:'work_name'},
            {label:'渠道分发ID',prop:'channel_id'},
            {label:'交稿时间',prop:'created_at'},
            {label:'审稿时间',prop:'check_time'},
            {label:'审核ID',prop:'check_id'},
            {label:'审核人',prop:'check_admin_name'},
            {label:'是否已审核',prop:'check_status',is_turn:true},//is_turn是否用get_status
            {label:'当前状态',prop:'check_status',is_turn:true}
        ],
        //项目征集表头
        tableTitle1:[
            {label:'用户ID',prop:'open_id'},
            {label:'用户头像',prop:'avatar'},
            {label:'用户昵称',prop:'username'},
            {label:'项目ID',prop:'project_id'},
            {label:'项目封面',prop:'banner'},
            {label:'项目名称',prop:'name'},
            {label:'交稿时间',prop:'user_delivery_time'},
            {label:'审稿时间',prop:'check_time'},
            {label:'审核ID',prop:'check_id'},
            {label:'审核人',prop:'check_admin_name'},
            {label:'是否审核',prop:'check_status',is_turn:true},
            {label:'当前状态',prop:'check_status',is_turn:true}
        ],
        tableData1: [],
        tableData2: [],
        drawer:false,
        direction:'rtl',
        rawer_list2:[
            {label:'用户ID',prop:'open_id',open_id:'',placeholder:"请输入用户ID检索",},
            {label:'用户昵称',prop:'username',username:'',placeholder:"请输入用户昵称检索"},
            {label:'作品ID',prop:'works_id',works_id:'',placeholder:"请输入作品ID检索"},
            {label:'作品名称',prop:'work_name',work_name:'',placeholder:"请输入作品名称检索"},
            {label:'渠道分发ID',prop:'channel_id',channel_id:'',placeholder:"请输入渠道分发ID检索"},
            {label:'是否已审核',prop:'is_check',is_check_list:[
                {
                    value: '-1',
                    label: '未审核'
                }, {
                    value: '1',
                    label: '已审核'
                }
            ],is_check:'',placeholder:"请选择是否已审核"},
            {label:'当前状态',prop:'check_status',check_status_list:[
                {
                    value: '0',
                    label: '待审核'
                }, {
                    value: '1',
                    label: '已审核'
                },
                {
                    value: '-1',
                    label: '已驳回'
                }, {
                    value: '-2',
                    label: '已撤销'
                }
            ],check_status:'',placeholder:"请选择当前状态"},
        ],
        rawer_list1:[
            {label:'用户ID',prop:'open_id',open_id:'',placeholder:"请输入用户ID检索",},
            {label:'用户昵称',prop:'username',username:'',placeholder:"请输入用户昵称检索"},
            {label:'项目ID',prop:'project_id',project_id:'',placeholder:"请输入项目ID检索"},
            {label:'项目名称',prop:'work_name',work_name:'',placeholder:"请输入项目名称检索"},
            {label:'是否已审核',prop:'is_check',is_check_list:[
                {
                    value: '-1',
                    label: '未审核'
                }, {
                    value: '1',
                    label: '已审核'
                }
            ],is_check:'',placeholder:"请选择是否已审核"},
            {label:'当前状态',prop:'check_status',check_status_list:[
                {
                    value: '0',
                    label: '未审核'
                }, {
                    value: '1',
                    label: '已审核'
                },
                {
                    value: '-1',
                    label: '已驳回'
                }, {
                    value: '-2',
                    label: '已撤销'
                }
            ],check_status:'',placeholder:"请选择当前状态"},
        ],
        rawer_list3:[
            {label:'用户ID',prop:'open_id',open_id:'',placeholder:"请输入用户ID检索",},
            {label:'用户昵称',prop:'username',username:'',placeholder:"请输入用户昵称检索"},
            {label:'摄影投稿ID',prop:'photography_id',photography_id:'',placeholder:"请输入摄影投稿ID检索"},
            {label:'是否已审核',prop:'is_check',is_check_list:[
                {
                    value: '-1',
                    label: '未审核'
                }, {
                    value: '1',
                    label: '已审核'
                }
            ],is_check:'',placeholder:"请选择是否已审核"},
            {label:'当前状态',prop:'check_status',check_status_list:[
                {
                    value: '0',
                    label: '未审核'
                }, {
                    value: '1',
                    label: '已审核'
                },
                {
                    value: '-1',
                    label: '已驳回'
                }, {
                    value: '-2',
                    label: '已撤销'
                }
            ],check_status:'',placeholder:"请选择当前状态"},
        ],
        boost_type:'1',// 项目征集1  摄影投稿2,
      }
    },
    computed:{
        rawer_list(){
            return this.activeName == '1' ? this.rawer_list1 :(this.activeName == '2'? this.rawer_list2:this.rawer_list3)
        }
    },
    mounted(){
        this.init()
    },
    methods:{
        handleClick(){
            this.data_obj = {
                total:0
            }
            this.page = 1
            this.get_switch(this.activeName)
        },
        set_limit(limit){
            this.page = 1
            this.limit = limit
            this.get_switch(this.activeName)
        },
        set_page(page){
            this.page = page
            this.get_switch(this.activeName)
        },
        get_switch(data){
            switch(data){
                case '1':
                    this.get_operate_boostRecords()
                    break;
                case '2':
                    this.get_operate_boostRecords()
                    break;
                default:
                    // 默认代码块
            } 
        },
        get_operate_boostRecords(data){
            let params = data ? data : {boost_type:this.boost_type,type:this.activeName,page:this.page,limit:this.limit}
            this.api.operate_boostRecords(params).then((res)=>{
                this.data_obj = res
                this[`tableData${this.activeName}`] = res.data
            })
        },
        handle(e){
            console.log(e)
        },
        screen(val){
            let obj = {boost_type:this.boost_type,type:this.activeName,page:this.page,limit:this.limit}
            obj = {...obj,...val}
            console.log(obj)
            this.get_operate_boostRecords(obj)
        },
        blur(val){
        },
        handleClose_drawer(){
            this.drawer = false
            let rawer_list = this.rawer_list
            rawer_list.forEach(val => {
                val[val.prop] = ''
            });
        },
        open_screen(){
            this.drawer = true
        },
        init(){
            this.api.operate_boostRecords({boost_type:this.boost_type,type:this.activeName,page:this.page,limit:this.limit}).then((res)=>{
                this.data_obj = res
                this.tableData1 = res.data
                console.log(this.data_obj,'this.data_obj')
            }).then(()=>{
               this.api.operate_boostRecords({boost_type:this.boost_type,type:2,page:this.page,limit:this.limit}).then((res)=>{
                    this.tableData2 = res.data
                }) 
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.expediting-records-container{
    width: 100%;
    .screen{
        display: flex;
        justify-content: flex-end;
        padding: 10px 30px;
    }
}
</style>